<template>
    <div class="carousel">
        <div class="auto">
            <swiper :options="swiperOption">
                <swiper-slide v-for="(item, index) in carousel" :data-pic="item.src" :key="index">
                    <img :src="item.src" />
                    <div class="txt" :class="{ center: index === 0, right: index === 2 }">
                        <h2>{{ item.title }}</h2>
                        <h3>{{ item.subTitle }}</h3>
                        <router-link to="/order" class="btn">
                            <el-button class="btn" type="success" plain>{{ item.btn }}</el-button>
                        </router-link>
                    </div>
                </swiper-slide>
                <!-- 前一頁 -->
                <div class="swiper-button-prev" slot="button-prev"></div>
                <!-- 下一頁 -->
                <div class="swiper-button-next" slot="button-next"></div>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
    </div>
</template>

<script>
export default {
    name: 'carousel',
    data() {
        return {
            swiperOption: {
                // 自動播放
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false
                },
                grabCursor: true,
                spaceBetween: 30,
                effect: 'fade',
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination'
                }
            }
        };
    },
    computed: {
        carousel() {
            return this.$store.state.carousel;
        }
    }
};
</script>

<style lang="scss" scoped>
.carousel {
    width: 100%;
    background: center/cover no-repeat url('./img/header-2.jpg');

    .auto {
        .swiper-wrapper {
            .swiper-slide {
                img {
                    width: 100%;
                    max-height: calc(100vh - 56px);
                    object-fit: cover;
                    vertical-align: middle;
                }
                .txt {
                    width: 100%;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 10%;
                    color: white;
                    h2 {
                        font-size: 40px;
                        line-height: 64px;
                    }
                    h3 {
                        font-size: 18px;
                        line-height: 32px;
                        font-weight: 600;
                    }
                    .btn {
                        margin: 16px 0 0;
                    }
                    &.center {
                        text-align: center;
                        left: 0;
                    }
                    &.right {
                        text-align: right;
                        right: 10%;
                        left: -10%;
                    }
                }
            }
        }
    }
}
</style>
